// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d4c10e0b","812":"3d063862","855":"f3c80dc2"}[chunkId] + ".chunk.js";
};